export default __webpack_public_path__ + "static/media/img_other1.df12b4af.webp";